import * as React from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { createTheme, ThemeProvider, styled } from "@mui/material/styles";
import { Input, Tooltip, Typography, Box } from "@mui/material";
import { grey } from "@mui/material/colors";
import Fab from "@mui/material/Fab";
import PrintIcon from "@mui/icons-material/Print";
import EditIcon from "@mui/icons-material/Edit";
import SaveAltIcon from "@mui/icons-material/SaveAlt";
import AddIcon from "@mui/icons-material/Add";
import IconButton from "@mui/material/IconButton";
import Button from "@mui/material/Button";
import SaveIcon from "@mui/icons-material/Save";
import CloseIcon from "@mui/icons-material/Close";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import { useEffect } from "react";

export default function BasicTable(props) {
  // console.log("🚀 ~ file: InfoDisplay.js ~ line 25 ~ BasicTable ~ props", props)
  const [edit, setEdit] = React.useState(false);
  const [scroll, setScroll] = React.useState(false);
  const [originalRow, setOriginalRow] = React.useState(false);
  const element = React.useRef(null);
  const focus = React.useRef(null);

  const prevEdit = React.useRef();

  const theme = createTheme({
    components: {
      // Name of the component
      MuiTableBody: {
        styleOverrides: {
          // Name of the slot
          root: {
            // Some CSS
            // backgroundColor: "red",
            maxHeight: "30px",
            overflow: "scroll",
          },
        },
      },
    },
  });

  useEffect(() => {
    // console.log(focus.current)
    // focus.current.input.focus()
    element.current.scrollIntoView({ block: "end", behavior: "smooth" });

    return setScroll(false);
  }, [scroll]);

  useEffect(() => {
    // console.log("edit n1", String(edit), prevEdit.current);

    if (
      prevEdit.current !== false &&
      prevEdit.current !== undefined &&
      prevEdit.current !== "saved" &&
      edit !== "saved"
    ) {
      // console.log("handle save", prevEdit.current);

      props.options?.handleSave?.(prevEdit.current);
    }

    prevEdit.current = edit;
  }, [edit]);

  // console.log("edit", prevEdit.current);

  return (
    <Box>
      <Typography
        variant="h5"
        sx={{ width: "100%", textAlign: "center" }}
        mb={3}
      >
        {props.header}
      </Typography>
      <TableContainer
        sx={{ maxHeight: "500px", height: "auto" }}
        component={Paper}
      >
        <Table stickyHeader sx={{ minWidth: 650 }} aria-label="simple table">
          <TableHead bgcolor={grey[400]}>
            <TableRow color="common.white">
              {props.columns.map((item) => (
                <TableCell align={item.align || "left"}>{item.name}</TableCell>
              ))}
              <TableCell align="center" sx={{ width: "100px" }}>
                Actions
              </TableCell>
            </TableRow>
          </TableHead>
          <ThemeProvider theme={theme}>
            <TableBody
              ref={element}
              sx={{ overflow: "auto", maxHeight: "500px", width: "100%" }}
            >
              {props.rows.map((row, index) => (
                <TableRow
                  key={index}
                  sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                >
                  {props.columns.map((item, i) => {
                    // console.log(`${row} ${index}`,row);
                    return (
                      <TableCell key={row.index} sx={{ minWidth: "75" }}>
                        {edit === index && item.edit
                          ? item.customInput?.(row, index, i) || (
                              <Input
                                autoFocus={i === 0 ? true : false}
                                value={row[props.columns[i].id]}
                                type={props.columns[i].type}
                                onChange={(e) =>
                                  props.options.handleEdit(
                                    e,
                                    row,
                                    props.columns[i].id,
                                    index
                                  )
                                }
                              />
                            )
                          : row[props.columns[i].id]}
                      </TableCell>
                    );
                  })}

                  <TableCell align="center">
                    {edit === index ? (
                      <>
                        <Tooltip title="Dont Save">
                          <CloseIcon
                            onClick={() => {
                              props.options?.handleDontSave?.(
                                originalRow,
                                index
                              );
                              setEdit("saved");
                            }}
                          />
                        </Tooltip>

                        <Tooltip title="Save">
                          <SaveIcon
                            sx={{ marginLeft: "5px", color: "primary.main" }}
                            onClick={() => {
                              setEdit("saved");
                              props.options?.handleSave(index, row);
                            }}
                          />
                        </Tooltip>
                      </>
                    ) : (
                      <>
                        <Tooltip title="Edit">
                          <EditIcon
                            onClick={() => {
                              setOriginalRow({ ...row });
                              setEdit(index);
                            }}
                          />
                        </Tooltip>

                        {props.options?.handleDelete ? (
                          <Tooltip title="Delete">
                            <DeleteForeverIcon
                              sx={{ marginLeft: "5px" }}
                              onClick={() => {
                                props.options?.handleDelete(row, index);
                              }}
                            />
                          </Tooltip>
                        ) : null}
                      </>
                    )}
                  </TableCell>
                </TableRow>
              ))}

              {props.options?.addRecord ? (
                <TableRow>
                  <TableCell>
                    <Button
                      variant="contained"
                      startIcon={<AddIcon />}
                      onFocus={() => {
                        props.options.addRecord();
                        setEdit(props.rows.length);
                        setScroll(true);
                      }}
                      onClick={() => {
                        props.options.addRecord();
                        setEdit(props.rows.length);
                        setScroll(true);
                      }}
                    >
                      Add Record
                    </Button>
                  </TableCell>
                </TableRow>
              ) : null}
            </TableBody>
          </ThemeProvider>
        </Table>
      </TableContainer>
      {/* <Fab
        color="secondary"
        sx={{ position: "absolute", bottom: 35, right: 35 }}
        onClick={() => setEdit(!edit)}
      >
        <EditIcon />
      </Fab>
      <Fab
        color="primary"
        sx={{ position: "absolute", bottom: 35, right: 100 }}
      >
        <PrintIcon />
      </Fab>
      <Fab
        color="warning"
        sx={{ position: "absolute", bottom: 35, right: 165 }}
      >
        <SaveAltIcon />
      </Fab> */}
    </Box>
  );
}
